import { usePortalData } from '../data/usePortalData';
export const useHasConfiguredColumn = propertyName => {
  const {
    data
  } = usePortalData();
  return !!(data !== null && data !== void 0 && data.configuredTicketProperties.some(column => column.propertyName === propertyName));
};